import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import APICom from "../../../../utils/helpers/APICom";

const IRTPU = (props) => {

  const { loginData } = useSelector((store) => store.login);
  const { ASCSSettingData, BrokerServingAffiliatesData } = useSelector((store) => store.combinedata);
  const [showIRTPUAlert, setIRTPUAlert] = useState(false);
  const [irtpuAlertObj, setIRTPUAlertObj] = useState({ alertTitle: '', alertMsg: '' });
  const [dispatchMethod, setDispatchMethod] = useState(0);

  useEffect(() => {
    let isMounted = true;
    const executeIRTPULogic = async () => {
      if (!isMounted) { return; } 
       if (!props.GridRowData || props.GridRowData.length <= 0) {
        setIRTPUAlertObj({ ...irtpuAlertObj, alertTitle: 'No trip selected', alertMsg: 'No request selected to perform IRTPU.' });
        setIRTPUAlert(true);
      }
      else {
        const gData = props.GridRowData[0];
        let filteredAffiliates = [];
        try {
          if(BrokerServingAffiliatesData !== "")
          {
            filteredAffiliates = BrokerServingAffiliatesData?.filter(
              (aff) => String(aff.iBrokerAffiliateID) === String(gData.iSRATSPID)
            );
          }
        }
        catch (e) {

        }
        if (filteredAffiliates?.length > 0) {
          setIRTPUAlertObj({ ...irtpuAlertObj, alertTitle: 'Action Restriction', alertMsg: `The trip is assigned to an Affiliate (${gData.Affiliate}) and only Affiliate can initiate this action.` });
          setIRTPUAlert(true);
        }
        else if (gData.TripRequestStatus.toLowerCase() === "irtpu") {
          setIRTPUAlertObj({ ...irtpuAlertObj, alertTitle: 'Action Failed', alertMsg: "Trip already in IRTPU state." });
          setIRTPUAlert(true);
        }
        else if (gData.TripRequestStatus.toLowerCase() === "dispatched" || gData.TripRequestStatus.toLowerCase() === "accepted") {
          if (ASCSSettingData !== null && ASCSSettingData !== undefined) {
            if (ASCSSettingData.hasOwnProperty(props.GridRowData[0].iSRATSPID)) {
              const ascsSettingDataByAffiliate = JSON.parse(ASCSSettingData[props.GridRowData[0].iSRATSPID]); // Parse JSON string into an array
              for (let i = 0; i < ascsSettingDataByAffiliate.length; i++) {
                if (ascsSettingDataByAffiliate[i]["SubTitle"] === "DispatchMethod") {
                  setDispatchMethod(ascsSettingDataByAffiliate[i]["value"]);
                }
              }
            }
          }

          await PerformManualIRTPU();
        }
        else {
          setIRTPUAlertObj({ ...irtpuAlertObj, alertTitle: 'Invalid Trip State', alertMsg: "'" + gData.ConfirmationNo + "' cannot be marked as IRTPU. Trip state is not Accepted." });
          setIRTPUAlert(true);
        }
      }
    }
    executeIRTPULogic();
    return () => {                                 // ADD THIS
        isMounted = false;                         // ADD THIS
        props.setIsProcessing(false);              // ADD THIS
        props.setIRTPUComponentLoad(false);         // ADD THIS
    }; 
  }, [props.GridRowData, BrokerServingAffiliatesData, ASCSSettingData]);


  const PerformManualIRTPU = async () => {
    const gData = props.GridRowData[0];
    var Param = {
      "iServiceID": gData.ServiceID,
      "DispatchedBy": dispatchMethod,
      "iRefID": gData.ConfirmationNo,
      "iUserID": loginData.iUserID
    }
    let response = await APICom.fetchData("", "TripActions/PerformManualIRTPU", "post", { "Content-Type": "application/json" }, Param, null);
    let result = response.data;
    if (result.count > 0) {
      setIRTPUAlertObj({ ...irtpuAlertObj, alertTitle: 'IRTPU Action', alertMsg: "Action performed successfully." });
      setIRTPUAlert(true);
      props.GridRowData[0].TripRequestStatus = 'IRTPU'
    }
    else {
      setIRTPUAlertObj({ ...irtpuAlertObj, alertTitle: 'IRTPU Failed', alertMsg: "Action failed." });
      setIRTPUAlert(true);
    }

    //props.ReloadDataFunction();
  }

  const handleIRTPUAlertClose = () => {
    setIRTPUAlert(false);
    UnMountIRTPUComponent();
  }

  const UnMountIRTPUComponent = () => {
    if (props.irtpuComponentLoaded) {
      props.setIsProcessing(false);
      props.setIRTPUComponentLoad(false);
    }
  }

  return (
    <>
      {showIRTPUAlert && <Modal centered show={showIRTPUAlert} onHide={handleIRTPUAlertClose} animation={false} >
        <Modal.Header className='activate_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
          <Modal.Title className='activate_dialog_title_color'>{irtpuAlertObj.alertTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body><b>{irtpuAlertObj.alertMsg}</b></Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleIRTPUAlertClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>}
    </>
  );
};


export default IRTPU;